'use strict';

/* ============================================================================
 * 						Element Tools
 * ============================================================================ */
var ElementTools = {};

/*
 * TODO:
 * 1) The shim to add classList needs testing and probably a rewrite.
 * 2) I should create a wiki page or blog
 * article on this stuff (e.g. how to do stuff w/o jquery. Select elements,
 * modify classlists, ajax request, etc., explain RaF and also our AFM class and
 * the listener class (e.g. .once(...)) ... Go over .bind(...) and class def and
 * static class es too.
 */

ElementTools.isSVGElement = function(elem) {
	return (elem instanceof SVGElement);
	/* TODO It appears this 'instanceof' check fails when used on an svg inside
	 * of an <object />. activeItem.ownerSVGElement !== undefined may be a good
	 * option... Or better check for Class instead
	 */
};

/* TODO: rename these and this class. Think of this as a mini-toolbox and make it so the array version of classlist editing can do single classes too. */
ElementTools.clearClassList = function(elem) {
	var classList = elem.classList;
	var len = classList.length;
	if (len > 0) {
		var classArray = new Array(len);
		for (var i = 0, len = len; i < len; i++) {
			classArray[i] = classList[i];
		}
		ElementTools.removeClassList(elem, classArray);
	}
}
ElementTools.removeClassList = function(elem, classArray) {
	if (classArray !== undefined && classArray.length > 0) {
		var classList = elem.classList;
		classList.remove.apply(classList, classArray);
	}
};
ElementTools.addClassList = function(elem, classArray) {
	if (classArray !== undefined && classArray.length > 0) {
		var classList = elem.classList;
		classList.add.apply(classList, classArray);
	}
};
ElementTools.setClassList = function(elem, classArray) {
	ElementTools.clearClassList(elem);
	ElementTools.addClassList(elem, classArray);
};

/**
 * @public
 * Finds closest ancestor or self that matches selector string.
 */
// TODO If we use sizzle we don't need this... wait don't we still? Anything else we don't need? ... But maybe get rid of or document that this does not use sizzle. Or just make it use sizzle.
ElementTools.findClosest = function(startElem, selectorString) {
	var curElem = startElem;
	do {
		if (curElem === undefined || curElem.matches === undefined) {
			return undefined;
		}
		if (curElem.matches(selectorString)) {
			return curElem
		}
	} while(curElem = curElem.parentNode);
}


/**
 * @public
 * Removes all classes from elem that start with the namePrefix.
 */
ElementTools.removePrefixedClasses = function(elem, namePrefix) {
	var classList = elem.classList;
	var classArray = new Array(classList.length);
	for (var i = 0, len = classList.length; i < len; i++) {
		var className = classList[i];
		if (className.indexOf(namePrefix) === 0) {
			classArray.push(className);
		}
	}
	ElementTools.removeClassList(elem, classArray);
}


var _transformStyleName;
function getTransformStyleName() {
	if (_transformStyleName === undefined) {
		_transformStyleName = ElementTools.getVendorStyleName('transform');
	}
	return _transformStyleName;
}
ElementTools.setTransform = function(elem, value) {
	// TODO Something like https://github.com/epistemex/transformation-matrix-js  maybe a great addition. Looks like it is now here: https://github.com/leeoniya/transformation-matrix-js ... or http://glmatrix.net/  and https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix and http://paperjs.org/reference/matrix/
	if (elem !== null) {
		if (this.isSVGElement(elem)) {
			elem.setAttribute('transform', value);
		} else {
			elem.style[getTransformStyleName()] = value;
		}
		return true;
	}
	return false;
};
ElementTools.getTransform = function(elem) {
	// TODO This should be using getComputedStyle shouldn't it?
	if (elem !== null) {
		if (this.isSVGElement(elem)) {
			elem.getAttribute('transform');
		} else {
			return elem.style[getTransformStyleName()];
		}
		return true;
	}
	return false;
}

ElementTools.getOffsetSum = function(elem) {
    var top = 0, left = 0, curElem = elem;
    while(curElem) {
        top = top + curElem.offsetTop;
        left = left + curElem.offsetLeft;
        curElem = curElem.offsetParent;
    }
    return {top: top, left: left};
};

var cssPrefixes = ['Webkit', 'Moz', 'ms'],
emptyStyle = document.createElement('div').style;
ElementTools.getVendorStyleName = function(name) {
	// Shortcut for names that are not vendor prefixed
	if (name in emptyStyle) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		i = cssPrefixes.length,
		prefixedName;
	while (i--) {
		prefixedName = cssPrefixes[i] + capName;
		if (prefixedName in emptyStyle) {
			return prefixedName;
		}
	}
	
	// Can't find property
	return null;
};

module.exports = ElementTools;



